import { render, staticRenderFns } from "./PresentacionCargaLpfListView.vue?vue&type=template&id=538c0ed5&"
import script from "./PresentacionCargaLpfListView.vue?vue&type=script&lang=js&"
export * from "./PresentacionCargaLpfListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
})
